export default __webpack_public_path__ + "7b2a1b6823b544e7410342eb7ccb9ae3.png";